import { render, staticRenderFns } from "./page2part7.vue?vue&type=template&id=9a9ab8dc&scoped=true"
import script from "./page2part7.vue?vue&type=script&lang=js"
export * from "./page2part7.vue?vue&type=script&lang=js"
import style0 from "./page2part7.vue?vue&type=style&index=0&id=9a9ab8dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9ab8dc",
  null
  
)

export default component.exports